const CreateVoucherType = {
  LIST: 1,
  SINGLE: 2
}
export default CreateVoucherType
